// ============================================
// INFRASTRUCTURE - Suscripcion Repository
// ============================================

import type { MiSuscripcion, ProspectoPremium } from '../../domain/entities';
import { axiosClient } from './axios-client';

export const suscripcionRepository = {
  async getMiSuscripcion(): Promise<MiSuscripcion> {
    const { data } = await axiosClient.get<MiSuscripcion>('/suscripciones/mi-suscripcion');
    return data;
  },

  async getProspecto(): Promise<ProspectoPremium> {
    const { data } = await axiosClient.get<ProspectoPremium>('/suscripciones/prospecto');
    return data;
  },

  async descartarProspecto(): Promise<void> {
    await axiosClient.post('/suscripciones/prospecto/descartar');
  },

  async marcarInteresProspecto(): Promise<void> {
    await axiosClient.post('/suscripciones/prospecto/interesado');
  },
};
